import React from "react";

import * as S from "./styles";

export const Tag = ({ text, theme }) => {
  return <S.Tag theme={theme}>{text}</S.Tag>;
};
